import clsx from 'clsx'
import styles from './styles.module.scss'
import { ISelectionCardProps } from './types'
import { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Checkbox } from '..'

const SelectionCard = forwardRef<HTMLInputElement, ISelectionCardProps>(
  (
    {
      align = 'center',
      checked,
      children,
      disabled,
      id,
      name,
      onBlur,
      onChange,
      onFocus,
      required,
      style,
      text,
      title,
      transparent = false,
    },
    ref,
  ) => {
    const [isSelected, setIsSelected] = useState(checked || false)
    const checkboxRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(ref, () => checkboxRef.current as HTMLInputElement, [])

    const handleCardClick = (e: React.MouseEvent) => {
      if (disabled) return
      if (checkboxRef.current && !(e.target instanceof HTMLLabelElement)) {
        checkboxRef.current.checked = !checkboxRef.current.checked
        setIsSelected(checkboxRef.current.checked)
        onChange?.(checkboxRef.current.checked)
      }
    }

    const handleCheckboxClick = (e: React.MouseEvent<HTMLInputElement>) => {
      if (disabled) return
      e.stopPropagation()
      setIsSelected(e.currentTarget.checked)
      onChange?.(e.currentTarget.checked)
    }

    return (
      <div
        className={clsx('mui-card-selection', styles.wrapper, {
          [styles.alignCenter]: align === 'center',
          [styles.alignLeft]: align === 'left',
          [styles.checked]: isSelected,
          [styles.disabled]: disabled,
          [styles.transparent]: transparent,
        })}
        style={style}
        onClick={handleCardClick}
      >
        <div className={styles.checkboxWrapper}>
          <Checkbox
            id={id}
            ref={checkboxRef}
            onClick={handleCheckboxClick}
            disabled={disabled}
            required={required}
            label=""
            onBlur={onBlur}
            size="sm"
            onFocus={onFocus}
            name={name}
            aria-label={title}
            {...(checked ? { checked } : {})}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.children}>{children}</div>
          <div className={styles.footer}>
            <h4 className={clsx('subtitle-16', styles.title)}>{title}</h4>
            {text && <p className={clsx('caption-12-regular', styles.text)}>{text}</p>}
          </div>
        </div>
      </div>
    )
  },
)
export default SelectionCard
